// extracted by css-extract-rspack-plugin
export default {"wrapper":"SuggestionPickerField_wrapper__GQMX-","error":"SuggestionPickerField_error__6wZGW","errorMessage":"SuggestionPickerField_errorMessage__eMU25"};